import {
    OverPaymentProperties,
    OverpaymentBankAccountProperties,
} from '@interfaces/cambio-via-pago-properties.interface';
import { VoucherProperties } from '@interfaces/voucher-properties.interface';
import { PaymentAVProps } from './business.constant';
import { INICIO } from './url.constant';

export enum WithdrawFilterNamesEnum {
    valeVista = 'valeVista',
    depositoBancario = 'depositoBancario',
}

export const CODE_FALABELLA_BANK = 51;
export const CODE_ACCOUNT_CORRIENTE = 'CC';
export const CODE_ACCOUNT_VISTA = 'CV';

export const BANK_ESTADO_CODE = 12;
export const BANK_SANTANDER_CODE = 37;
export const RUT_ACCOUNT_CODE = 'CR';
export const TYPES_BANKS = 'types_banks';
export const SELECTED_BANK = 'selected_bank';
export const SOLICITUD_VIA_PAGO_RESPONSE = 'solicitud_via_pago_response';
export const TYPES_BANKS_ACCOUNTS = 'types_banks_accounts';

export const MAX_DEFAULT_ACCOUNT_NUMBER = '000000000000000000';

export const CAMBIO_VIA_PAGO_PROPERTIES: OverPaymentProperties = {
    title: 'Elige un tipo de depósito',
    subtitle: 'Selecciona en dónde quieres recibir tu Pago en Exceso',
    optionsDeposit: [
        {
            icon: '/assets/icons/attach_money_24px.svg',
            primaryLabel: 'Depósito bancario',
            secondaryLabel: 'Elige una cuenta o agrega una nueva',
            filterName: WithdrawFilterNamesEnum.depositoBancario,
        },
        {
            icon: 'assets/icons/request_page.svg',
            primaryLabel: 'Vale vista',
            secondaryLabel: 'Emitido por Banco Santander',
            filterName: WithdrawFilterNamesEnum.valeVista,
            extraData: PaymentAVProps,
        },
    ],
    importantMessages: {
        title: 'Importante:',
        messages: [
            'Puedes optar por un depósito bancario en una cuenta unipersonal que esté a tu nombre o retira con un vale vista en Banco Santander',
            'Si tu depósito es rechazado, se emitirá un vale vista en el Banco Santander',
            'Para la Cuenta Rut de Banco Estado, el depósito puede ser rechazado si excede el monto de $4.000.000 mensuales o si tu saldo en tu cuenta es mayor a $5.000.000',
        ],
    },
};

export const CAMBIO_VIA_PAGO_BANK_ACCOUNT_PROPERTIES: OverpaymentBankAccountProperties =
    {
        title: 'Elige una cuenta bancaria',
        subtitle: 'Selecciona o agrega una nueva cuenta',
        importantMessages: {
            title: 'Ten en cuenta que:',
            messages: [
                'La cuenta seleccionada debe estar a tu nombre y debe ser unipersonal. De lo contrario, el depósito será rechazado y se emitirá un vale vista en el Banco Santander',
            ],
        },
    };

export const CAMBIO_VIA_PAGO_GENERIC_ERROR = {
    titleRetry:
        'Lo sentimos, en este momento no podemos atender tu solicitud',
    subtitleRetry: 'Ante dudas llámanos al <b>600 6600 900</b>, escríbenos a WhatsApp <b>+569 3639 1222</b> o dirígete a nuestras sucursales.',
    infoRetry: 'Por favor, reinténtalo o ingresa más tarde',
    srcImage: '/assets/contactotdp/icons/info_fill.svg',
    buttonTextPrimary: 'Reintentar',
    buttonTextSecondary: 'Ir a Inicio',
    buttonUrlSecondary: INICIO,
};

export const CAMBIO_VIA_PAGO_DATOS_PERSONALES_ERROR = {
    titleRetry:
        'Aún no registras tu correo, ni tu teléfono',
    subtitleRetry: 'Para actualizar tus datos, contáctate con nuestro Call Center al <b>600 6600 900</b> o al WhatsApp <b>+569 3639 1222</b>, también puedes dirigirte a nuestras sucursales',
    infoRetry: 'Recuerda que es necesario registrar tus datos personales, ya que te contactaremos en caso que sea necesario',
    srcImage: '/assets/contactotdp/icons/info_fill.svg',
    buttonTextPrimary: 'Contactar al WhatsApp',
    buttonTextSecondary: 'Salir',
};


export const CAMBIO_VIA_PAGO_CONFIRM_GENERIC_ERROR = {
    titleRetry:
        'Ocurrió un error al ingresar tu solicitud de Giro',
    subtitleRetry: 'Ante dudas llámanos al <b>600 6600 900</b>, escríbenos a WhatsApp <b>+569 3639 1222</b> o dirígete a nuestras sucursales.',
    infoRetry: 'Por favor, reinténtalo o ingresa más tarde',
    srcImage: '/assets/contactotdp/icons/info_fill.svg',
    buttonTextPrimary: 'Reintentar',
    buttonTextSecondary: 'Ir a Inicio',
    buttonUrlSecondary: INICIO,
};

export const ORIGEN_VALIDAR_CUENTAS_DIGITALES = 'validar_cuentas_digitales';
export const ORIGEN_VALIDAR_API_SANTANDER = 'validar_api_santander';
export const ORIGEN_VALIDAR_CUENTA_DUPLICADA = 'validar_cuenta_duplicada';

export const VOUCHER_PAGE_PROPERTIES: VoucherProperties = {
    srcImage: '../../../../../assets/icons/success-blue.svg',
    titleSuccess: 'Recibimos tu solicitud de cambio de vía de pago de pensión',
    subtitleSucces: '¿Que viene ahora?',
    infoSucces: 'Validaremos tus datos y te contactaremos en caso de ser necesario. Una vez recibas el comprobante de cambio por correo, comenzarás a recibir la pensión en tu cuenta bancaria al mes siguiente',
    subtitleSuccesEmail: 'Este es tu comprobante',
    infoSuccesClientWithEmail:'También lo enviamos a tu correo ?. Si no lo encuentras en tu bandeja principal, por favor, revisa el spam',
    infoSuccesClientWithoutEmail:'Aún no registras un correo para recibir tus comprobantes, por favor agrega uno en ',
    buttonText: 'Ir a Inicio',
    goBackText: 'Volver a Cambio vía de pago de pensión'
};

export const CONFIRM_GENERIC_ERROR = {
    titleRetry:'Lo sentimos, ocurrió un error al cargar la información',
    subtitleRetry: 'Ante dudas llámanos al <b>600 6600 900</b>, escríbenos a WhatsApp <b>+569 3639 1222</b> o dirígete a nuestras sucursales.',
    infoRetry: 'Por favor, reinténtalo o ingresa más tarde',
    srcImage: '/assets/contactotdp/icons/info_fill.svg',
    buttonTextPrimary: 'Reintentar',
    buttonTextSecondary: 'Ir a Inicio',
    buttonUrlSecondary: INICIO,
};

export const CONFIRM_SOLICITUD_ERROR = {
    titleRetry:'Ocurrió un error al ingresar tu solicitud de cambio de vía de pago de pensión',
    subtitleRetry: 'Ante dudas llámanos al <b>600 6600 900</b>, escríbenos a WhatsApp <b>+569 3639 1222</b> o dirígete a nuestras sucursales.',
    infoRetry: 'Por favor, reinténtalo o ingresa más tarde',
    srcImage: '/assets/contactotdp/icons/info_fill.svg',
    buttonTextPrimary: 'Reintentar',
    buttonTextSecondary: 'Ir a Inicio',
    buttonUrlSecondary: INICIO,
};

export const CONFIRM_GENERIC_ERROR_BANK = {
    titleRetry:'Lo sentimos, ocurrió un error al cargar la información',
    srcImage: '/assets/contactotdp/icons/info_fill.svg',
    buttonTextPrimary: 'Reintentar',
    buttonTextSecondary: 'Ir a Inicio',
    buttonUrlSecondary: INICIO,
};

export const CONFIRM_GENERIC_ERROR_VALID_BANK = {
    titleRetry:'Lo sentimos, en este momento no podemos atender tu solicitud',
    srcImage: '/assets/contactotdp/icons/info_fill.svg',
    buttonTextPrimary: 'Reintentar',
    buttonTextSecondary: 'Ir a Inicio',
    buttonUrlSecondary: INICIO,
};
